import { CustomerQueryKeys } from "../Customer/keys";

export const CustomerApplicationQueryKeys = {
  all: (customerId: string) => [
    ...CustomerQueryKeys.single(customerId),
    "applications",
  ],
};
